import MobileDeveloperPage from "./MobileDeveloperPage";

export default function AndroidDeveloperPage() {
  return <MobileDeveloperPage technology="android" />;
}
